import React from 'react';
import { ModuleCarousel } from '../../ModuleCarousel';
export const HeroBodyCarousel = React.forwardRef(({ carouselSlides = [], onShowSlide = () => { }, shouldAnimate }, _ref) => {
    const slides = [...carouselSlides].filter(Boolean);
    return (React.createElement(ModuleCarousel, { contentType: "heroBodyCarousel", shouldAnimate: shouldAnimate, slides: slides, onShowSlide: onShowSlide }));
});
//# sourceMappingURL=index.js.map